<template id="salesman-compare">
  <section>
    <div
        class="card m-1"
        :class="this.$store.state.bannerStatus ? 'card-true' : 'card-false'"
    >
      <div class="card-header d-flex justify-content-between p-0">
        <div class="d-flex flex-wrap justify-content-start mt-1">
          <div class="header-left-row">
            <strong class="ml-2">
              <span ref="screenNameSpan" v-if="$store.state.deviceType !== 'Mobile'">{{ screenName }}</span>
            </strong>
            <i v-if="distinctScreenlet.length>1"
               :class="isTabbedView ? 'fas fa-list' : 'fas fa-square'"
               :title="isTabbedView ? 'Tabbed View' : 'Storyboard View'"
               style="font-size: 18px; cursor: pointer; padding-left: 12px;"
               @click="isTabbedView = !isTabbedView">
            </i>
            <i v-if="Object.entries(screenListboxDim).length > 0 && $store.state.deviceType !== 'Mobile'"
               v-b-tooltip.hover.right
               title="Fixed / Flexi-Filter" :class="isToggled ? 'fa fa-toggle-on' : 'fa fa-toggle-off'"
               @click="toggleButtonFunction"
               style="cursor: pointer; margin-left: 10px;"
               aria-hidden="true">
            </i>
            <div class="d-flex ml-2" v-if="distinctScreenlet.length > 1 && isToggled && isTabbedView">
              <div
                  v-for="(r, index) of distinctScreenlet"
                  :key="'tab-' + r"
                  class="custom-header"
                  :class="{ 'active': activeTabIndex === index }"
                  @click="activeTabIndex = index"
                  :title="getTooltipText(r, index)"
              >
                <span style="font-size: 14px">{{ screenletShortName(r,index) }} {{ index + 1 }}</span>
              </div>
            </div>
            <div align="left" v-if="isToggled === false">
              <div class="mr-auto p-1 d-flex align-items-center">
                <!-- Reset Button -->
                <div v-if="screenListboxType === 'freeForm' || screenListboxType === 'anyWhichWay'">
                  <button class="btn-sm btn-outline-danger" @click="resetLb()">Reset</button>
                </div>

                <!-- Submit Button -->
                <div v-if="menuPath === '/post-load'" style="margin-left: 10px;">
                  <button id="button" class="btn-sm btn-warning" @click="handleSubmit">Submit</button>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(item, idx) of screenListboxDim" :key="idx" style="margin-top: -15px">
            <!-- Text input for fields marked as inputField -->
            <div v-if="item.isInputField && isToggled===false" class="mr-auto p-2">
              <span>{{ SlistboxDimBizName[idx] }}:</span>
              <input
                  type="text"
                  :value="getFilterValue(item.name)"
                  @input="updateFilter(item.name, $event.target.value)"
                  class="input-feild"
                  placeholder="Enter Value"
              />
            </div>

            <!-- Multiselect for regular fields when not toggled -->
            <div v-if="!item.isInputField && isToggled===false" class="mr-auto p-2">
              <span>{{ SlistboxDimBizName[idx] }}:</span>
              <div class="anyWhichWay" v-if="screenListboxType === 'anyWhichWay'">
                <multiselect
                    :ref="`multiselect-${item.name}`"
                    v-model="filter[item.name]"
                    :options="getOptionsWithSelectAll(item.name)"
                    :multiple="true"
                    :limit="1"
                    select-label="Select"
                    deselect-label="Unselect"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :append-to-body="true"
                    :clear-on-close="true"
                    track-by="value"
                    label="label"
                    @input="handleOptionSelected(item.name, $event)"
                    @select="onSelect(item.name, $event)"
                    :open="isOpen"

                >
                  <template v-slot:option="{ option }">
                    <label
                        v-if="option.value === selectAllValue"
                        class="custom-option"
                        :class="{ 'disable-parent-click': !isOptionSelected(item.name, option.value) }"
                    >
                      <input
                          type="checkbox"
                          :checked="isOptionSelected(item.name, option.value)"
                          @change="handleCheckboxChange(item.name, option.value, $event)"
                      />
                      {{ option.label }}
                    </label>
                    <label
                        v-else
                        class="custom-option"
                        @click.prevent="isOptionSelected(item.name, option.value)"
                    >
                      <input
                          type="checkbox"
                          :checked="isOptionSelected(item.name, option.value)"
                          @change="handleCheckboxChange(item.name, option.value, $event)"
                          @click.stop
                      />

                      {{ option.label }}

                    </label>
                  </template>
                  <template v-slot:afterList>
                    <div class="multiselect-footer">
                      <button class="btn-sm btn-success" type="button" @click="handleSubmit(item.name)">Ok</button>
                      <button class="btn-sm btn-warning " type="button" @click="onCancelClick(item.name)">Cancel
                      </button>
                    </div>
                  </template>
                </multiselect>
              </div>
              <div class="freeForm" v-else>
                <multiselect
                    :ref="`multiselect-${item.name}`"
                    v-model="filter[item.name]"
                    :options="getOptionsWithSelectAll(item.name)"
                    :multiple="true"
                    :limit="1"
                    select-label="Select"
                    deselect-label="Unselect"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :append-to-body="true"
                    :clear-on-close="true"
                    track-by="value"
                    label="label"
                    @input="handleOptionSelected(item.name, $event)"
                    @select="onSelect(item.name, $event)"
                    @open="isOpen = true"
                    @close="isOpen = false"
                >
                  <template v-slot:option="{ option }">
                    <label
                        v-if="option.value === selectAllValue"
                        class="custom-option"
                        @click.prevent="isOptionSelected(item.name, option)"
                        :class="{ 'disable-parent-click': !isOptionSelected(item.name, option.value) }"
                    >
                      <input
                          type="checkbox"
                          :checked="isOptionSelected(item.name, option.value)"
                          @change="handleCheckboxChange(item.name, option.value, $event)"
                      />
                      {{ option.label }}
                    </label>
                    <label
                        v-else
                        class="custom-option"
                        @click.prevent="isOptionSelected(item.name, option.value)"
                    >
                      <input
                          type="checkbox"
                          :checked="isOptionSelected(item.name, option.value)"
                          @change="handleCheckboxChange(item.name, option.value, $event)"
                          @click.stop
                      />

                      {{ option.label }}

                    </label>
                  </template>
                  <template v-slot:afterList>
                    <div class="multiselect-footer">
                      <button class="btn-sm btn-success" type="button" @click="handleSubmit(item.name)">Ok</button>
                      <button class="btn-sm btn-warning " type="button" @click="onCancelClick(item.name)">Cancel
                      </button>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <div v-if="Object.entries(screenListboxDim).length > 0 && isToggled" class="p-1">
          <button @click="showFilterDialog" class="btn btn-sm py-1 px-2"
                  v-bind:class="{'btn-primary': filterIsSelected, 'btn-info': !filterIsSelected}">
            <span style="font-size: .7rem"><i class="fas fa-filter"></i></span>
            <span class="ml-1" v-if="!filterIsSelected">Filter</span>
            <span class="ml-1" v-else>{{ filterCount }}<span v-if="$store.state.deviceType !== 'Mobile'"> Filter(s) Applied</span></span>
          </button>
        </div>
      </div>
      <div
          v-if="distinctScreenlet.length == 1"
          v-bind:class="screenCardStyle == 'card-deck' ? 'card-deck' : ''"
      >
        <div class="card" v-for="i in counter" v-bind:key="i">
          <entity-dashboard
              :scrnPropTime="scrnPropTime"
              :screenlet="i"
              :screenletId="distinctScreenlet[0]"
              :sl="x"
              :passedParam="passParam"
          ></entity-dashboard>
        </div>
      </div>
      <!-- When multiple screenlets → tab-based rendering -->
      <div v-if="distinctScreenlet.length > 1">
        <div class="viz-tabs-container" v-if="isTabbedView">
          <div class="custom-headers" v-if="distinctScreenlet.length > 1 && isToggled === false">
            <div
                v-for="(r, index) of distinctScreenlet"
                :key="'tab-' + r"
                class="custom-header"
                :class="{ 'active': activeTabIndex === index }"
                @click="activeTabIndex = index"
                :title="getTooltipText(r, index)"
            >
              <span style="font-size: 14px">{{ screenletShortName(r,index) }} {{ index + 1 }}</span>
            </div>
          </div>
          <entity-dashboard
              :scrnPropTime="scrnPropTime"
              :screenlet="activeTabIndex"
              :screenletId="distinctScreenlet[activeTabIndex]"
              :sl="x"
              :passedParam="passParam"
          >
          </entity-dashboard>
        </div>

        <div v-else>
          <div class="card" v-for="scrlet in distinctScreenlet" v-bind:key="scrlet">
            <entity-dashboard
                :scrnPropTime="scrnPropTime"
                :screenlet="scrlet"
                :screenletId="scrlet"
                :sl="x"
            >
            </entity-dashboard>
          </div>
        </div>
      </div>

      <div
          v-else
          v-bind:class="screenCardStyle == 'card-deck' ? 'card-deck' : ''"
      >
        <!--        <div v-for="scrlet in distinctScreenlet" v-bind:key="scrlet">{{scrlet}}</div>-->
        <entity-dashboard
            v-for="scrlet in distinctScreenlet"
            v-bind:key="scrlet"
            :scrnPropTime="scrnPropTime"
            :screenlet="scrlet"
            :screenletId="scrlet"
            :sl="x"
            :passedParam="passParam"
        ></entity-dashboard>
      </div>
    </div>
    <dialog ref="dialog">
      <input ref="hiddenInput" type="text" style="position: absolute; opacity: 0;width: 0">
      <div class="d-flex flex-column h-100">
        <button @click="hideFilterDialog" class="btn btn-outline"
                style="position: absolute; right: 10px; top: 30px;font-size: small; background-color: white">
          X
        </button>
        <h5 class="text-left mb-2 pb-2" style="border-bottom: 1px solid #ccc">Filters for {{ screenName }}</h5>
        <div>
          <common-alert
              :is-visible="showAlert"
              :dismiss-secs="7"
              message="This Menu Requires a Pre Selection Filter,Please Choose."
              variant="warning"
              @dismissed="onAlertDismissed"
          />
        </div>
        <common-alert
            :is-visible="showError"
            :dismiss-secs="7"
            message="Please select at least one filter."
            variant="warning"
            @dismissed="onAlertDismissed"
        />
        <div class="flex-grow-1 mb-3" style="overflow-y: auto; overflow-x: hidden">
          <div class="row">
            <div v-for="(item,idx) of screenListboxDim" :key="idx"
                 class="col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column">
                <span class="text-left" style="font-size: .8rem; font-weight: bold">{{
                    SlistboxDimBizName[idx]
                  }}</span>

              <input v-if="item.isInputField"
                     type="text"
                     :value="getFilterValue(item.name)"
                     @input="updateFilter(item.name, $event.target.value)"
                     class="form-control"
                     placeholder="Enter Value"
              />
              <div v-else>
                <div class="anyWhichWay" v-if="screenListboxType === 'anyWhichWay'">
                  <multiselect
                      v-model="filter[item.name]"
                      :options="getOptionsWithSelectAll(item.name)"
                      :multiple="true"
                      :limit="1"
                      select-label="Select"
                      deselect-label="Unselect"
                      :close-on-select="false"
                      :clear-on-select="true"
                      :clear-on-close="true"
                      :append-to-body="true"
                      track-by="value"
                      label="label"
                      @input="handleOptionSelected(item.name, $event)"
                      @select="onSelect(item.name, $event)"
                  >
                    <template v-slot:option="{ option }">
                      <label
                          v-if="option.value === selectAllValue"
                          class="custom-option"
                          :class="{ 'disable-parent-click': !isOptionSelected(item.name, option.value) }"
                      >
                        <input
                            type="checkbox"
                            :checked="isOptionSelected(item.name, option.value)"
                            @change="handleCheckboxChange(item.name, option.value, $event)"
                        />
                        {{ option.label }}
                      </label>
                      <label
                          v-else
                          class="custom-option"
                          @click.prevent="isOptionSelected(item.name, option.value)"
                      >
                        <input
                            type="checkbox"
                            :checked="isOptionSelected(item.name, option.value)"
                            @change="handleCheckboxChange(item.name, option.value, $event)"
                            @click.stop
                        />

                        {{ option.label }}

                      </label>
                    </template>
                  </multiselect>
                </div>
                <div class="freeForm" v-else>
                  <multiselect
                      v-model="filter[item.name]"
                      :options="getOptionsWithSelectAll(item.name)"
                      :multiple="true"
                      :limit="1"
                      select-label="Select"
                      deselect-label="Unselect"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :clear-on-close="true"
                      :append-to-body="true"
                      track-by="value"
                      label="label"
                      @input="handleOptionSelected(item.name, $event)"
                      @select="onSelect(item.name, $event)"
                  >
                    <template v-slot:option="{ option }">
                      <label
                          v-if="option.value === selectAllValue"
                          class="custom-option"
                          :class="{ 'disable-parent-click': !isOptionSelected(item.name, option.value) }"
                      >
                        <input
                            type="checkbox"
                            :checked="isOptionSelected(item.name, option.value)"
                            @change="handleCheckboxChange(item.name, option.value, $event)"
                        />
                        {{ option.label }}
                      </label>
                      <label
                          v-else
                          class="custom-option"
                          @click.prevent="isOptionSelected(item.name, option.value)"
                      >
                        <input
                            type="checkbox"
                            :checked="isOptionSelected(item.name, option.value)"
                            @change="handleCheckboxChange(item.name, option.value, $event)"
                            @click.stop
                        />

                        {{ option.label }}

                      </label>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button id="button" class="btn-sm btn-success"
                  @click="handleSubmit"> Submit
          </button>
          <button class="btn btn-sm ml-2 text-warning border border-warning" @click="resetLb()" title="Reset"
                  style="background-color: transparent;">
            Clear <i class="fas fa-times-circle"></i>
          </button>
        </div>
      </div>
    </dialog>
  </section>
</template>
<script>
import entityDashboard from "@/components/screenlet_seq_test_2";
import axios from "axios";
import Multiselect from "vue-multiselect/src/Multiselect.vue";
import CommonAlert from "@/components/CommonAlert.vue";
import {apiAbort} from "@/common/apiAbort";

export default {
  name: "salesman-compare",
  components: {CommonAlert, Multiselect, entityDashboard},
  data: () => ({
    counter: null,
    screenletMaxCount: null,
    screenletAdditionFlag: null,
    scrnPropTime: null,
    optionValues: ["a", "b"],
    screenName: "",
    x: {}, //need to revisit to make it dynamic
    y: {},
    li: 0,
    screenListboxCount: null,
    orderbyTextJson: {},
    screenListboxDim: {},
    dateRangeFilterFlag: "",
    SlistboxDimBizName: {},
    currentMenuActionIconsData: {},
    currentMenuListboxData: {},
    dateRangeFilterShortcuts: {},
    shortcuts: [],
    temp: [],
    promises: [],
    rowColMap: {},
    screenListboxType: null,
    example: [],
    screenListboxDefault: {},
    screenCardStyle: "",
    distinctScreenlet: [],
    activeTabIndex: 0,
    isToggled: false,
    time3: '',
    filter: {},
    isOpen: false,
    showAlert: false,
    showError: false,
    listBoxCache: {},
    selectAllValue: 'All',
    menuPath: '',
    passParam: {},
    isTabbedView:false,
    allScreenData:[]
  }),
  computed: {
    filterCount() {
      // eslint-disable-next-line no-unused-vars
      return Object.entries(this.filter).filter(([k, v]) => {
        if (Array.isArray(v)) {
          return v.some(val => val != null);  // Only count if there's a valid value
        } else {
          return v != null;  // Only count if non-null and non-undefined
        }
      }).length
    },
    filterIsSelected() {
      return this.filterCount > 0
    }
  },
  created() {
    this.screenRender();
    this.listenToRouter();
    this.loadListbox();
  },
  watch: {
    distinctScreenlet() {
      this.activeTabIndex = 0;
    },
  },
  methods: {
    onAlertDismissed() {
      this.showAlert = false; // Set showAlert to false when dismissed
      this.showError = false
    },
    resetLb: function () {
      console.log("reset function called")
      this.x = {}
      this.filter = {}
      this.loadViz = false
    },
    showFilterDialog() {
      this.$refs["dialog"].showModal()
    },
    hideFilterDialog() {
      this.$refs["dialog"].close()
    },
    toggleButtonFunction() {
      this.isToggled = !this.isToggled;
    },
    onCancelClick(itemName) {
      const ref = this.$refs[`multiselect-${itemName}`]
      if (ref && ref[0]) {
        ref[0].deactivate()
      }
    },
    handleSubmit(itemName) {
      // close the dropdown
      const ref = this.$refs[`multiselect-${itemName}`]
      if (ref && ref[0]) {
        ref[0].deactivate()
      }
      // Transform the filter first
      const transformedFilter = this.transformFilter(this.filter);
      this.$store.commit('setFilterFlag', true);
      if (!this.isAnyFilterSelected) {
        if (this.menuPath === '/post-load') {
          this.showError = true;
          return;
        }
      }
      this.passParam = transformedFilter
      this.scrnPropTime = new Date();
      this.showError = false;
      this.hideFilterDialog();
    },
    getFilterValue(key) {
      // Now handling both string keys (legacy) and object structure
      const filterKey = typeof key === 'object' ? key.name : key;
      return Array.isArray(this.filter[filterKey])
          ? this.filter[filterKey][0] || ''
          : this.filter[filterKey] || '';
    },
    updateFilter(key, value) {
      const filterKey = typeof key === 'object' ? key.name : key;
      if (value === null || value === '') {
        this.$delete(this.filter, filterKey);
      } else {
        this.$set(this.filter, filterKey, [value]);
      }
      if (this.menuPath === '/post-load') {
        this.toggleButton();
      } else {
        this.optionSelected(this.filter);
      }
    },
    onSelect(key, option) {
      if (option.value === this.selectAllValue) {
        // Trigger same logic as label click
        this.handleCheckboxChange(key, option.value, {target: {checked: true}});
      }
    },
    // Get options for multiselect, including "Select All"
    getOptionsWithSelectAll(key) {
      const options = (this.listBoxOptions[key] || []).map(opt => ({
        value: opt,
        label: opt,
      }));
      return [{value: this.selectAllValue, label: 'Select All'}, ...options];
    },

    // Check if an option is selected
    isOptionSelected(key, value) {
      if (!this.filter[key]) return false;
      if (value === this.selectAllValue) {
        const allOptions = (this.listBoxOptions[key] || []).map(opt => opt);
        return allOptions.length > 0 && allOptions.every(opt =>
            this.filter[key].some(selected => selected.value === opt)
        );
      }
      return this.filter[key].some(opt => opt.value === value);
    },
    // Handle checkbox change
    handleCheckboxChange(key, value, event) {
      const isChecked = event.target.checked;
      let currentSelection = this.filter[key] ? [...this.filter[key]] : [];

      if (value === this.selectAllValue) {
        if (isChecked) {
          // Select all options
          currentSelection = (this.listBoxOptions[key] || []).map(opt => ({
            value: opt,
            label: opt,
          }));
        } else {
          // Deselect all options
          currentSelection = [];
        }
      } else {
        if (isChecked) {
          // Add the selected option
          if (!currentSelection.some(opt => opt.value === value)) {
            currentSelection.push({value, label: value});
          }
        } else {
          // Remove the deselected option
          currentSelection = currentSelection.filter(opt => opt.value !== value);
        }
      }
      // Update the filter and trigger the multiselect update
      this.$set(this.filter, key, currentSelection);
      this.handleOptionSelected(key, currentSelection);
    },
    handleOptionSelected(key, selected) {
      this.$set(this.filter, key, selected);
      const transformedFilter = this.transformFilter(this.filter);
      this.optionSelected(transformedFilter);
    },
    async optionSelected() {
      //const transformedFilter = this.transformFilter(filter);
      this.listBoxOptions = await this.makeListBoxOptions();
      // this.$store.commit('setFilterFlag', true);
      this.sortDateRelatedObjects(this.listBoxOptions);
      console.log("this.listBoxOptions", this.listBoxOptions);
      if (this.menuPath === '/post-load') {
        await this.toggleButton();
      }
      if (this.isToggled === false && this.menuPath !== '/post-load') {
        await this.toggleButton();
      }
      return true;
    },
    toggleButton: async function () {
      let element = document.getElementById("button");
      element.classList.remove("btn-success")
      element.classList.add("btn-warning");
    },
    transformFilter(filter) {
      const result = {...filter};
      for (const key in result) {
        const value = result[key];
        if (Array.isArray(value) && value.length > 0) {
          // Check if it's an array of objects with 'value' property
          const firstItem = value[0];
          if (firstItem && typeof firstItem === 'object' && 'value' in firstItem) {
            // Extract just the 'value' properties
            result[key] = value.map(item => item.value);
          }
        }
      }
      return result;
    },
    incrementValue() {
      this.counter++;
    },
    decrementValue() {
      this.counter--;
    },
    resetValue() {
      this.counter = 0;
    },
    getTooltipText(row,index) {
      console.log("screens",row,this.allScreenData[index])
      return this.allScreenData[index].screenletTitleDpName;
    },
    screenletShortName(row,index) {
      console.log(row)
      try {
        return this.allScreenData[index].screenletTitleDpShortName;
      } catch (error) {
        console.error('Error getting vizlet short name:', error);
      }

      // Default fallback
      return 'Card';
    },
    screenRender: function () {
      let submenuParam = this.$route.params.submenuId;
      const config = this.$store.state.fwMClient[0]?.clientConfigParam?.dashboardDisplayConfig?.viewType;
      const roleConfig = this.$store.state.userRoleRestriction.roleConfigParam?.dashboardDisplayConfig?.viewType;
      const menuConfig = this.$store.state.menuMasterFlat.find(item => item.menuId === submenuParam)?.viewType;
      console.log(menuConfig)
      // Use roleConfig first, fallback to config if roleConfig is undefined/null
      const dashboardConfig = menuConfig ?? roleConfig ?? config;

      if (dashboardConfig) {
        this.isTabbedView = dashboardConfig === "Tab";
      }
      console.log("scr", "load state");
      this.$store.dispatch("loadState").then(() => {
        let allMenuScreenData = this.$store.state.fwConfigMenuScreenRender;
        console.log("Menu Screen Data", allMenuScreenData);
        let menuScreenData = allMenuScreenData.filter(
            (r) => r.menuId === submenuParam
        );
        this.allScreenData = allMenuScreenData.filter(
            (r) => r.menuId === submenuParam
        );
        this.counter = menuScreenData[0].screenletDefaultCount;
        this.screenletMaxCount = menuScreenData[0].screenletMaxCount;
        this.screenletAdditionFlag = menuScreenData[0].screenletAdditionFlag;
        this.distinctScreenlet = [
          ...new Set(menuScreenData.map((item) => item.screenletInstanceId)),
        ];
        console.log("Distinct screenlet", this.distinctScreenlet);
        console.log(
            "screenlet Param",
            this.counter,
            this.screenletMaxCount,
            this.screenletAdditionFlag
        );
      });
    },
    fetchListboxData: async function (sqlId) {
      const controller = apiAbort.new()

      try {
        const res = await axios.get(`/api/fetchListboxData/${sqlId}`, {
          signal: controller.signal,
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        })

        const removeEmptyOrNull = (obj) => {
          Object.keys(obj).forEach(k =>
              (obj[k] && typeof obj[k] === 'object' && removeEmptyOrNull(obj[k])) ||
              (!obj[k] && obj[k] !== undefined && delete obj[k])
          )
          return obj
        }

        let restrictedArray = this.$store.state.user.userRoleRestriction.menuAccessInclusionArray || []
        let exclusionArray = this.$store.state.user.userRoleRestriction.menuAccessExclusionArray || []

        const isAllMenusAllowed =
            !restrictedArray ||
            restrictedArray.length === 0 ||
            (restrictedArray.length === 1 && restrictedArray[0] === "[]")

        let data = this.$route.params.submenuId === "AB"
            ? res.data.filter(item => {
              if (isAllMenusAllowed) return true

              const isIncluded =
                  restrictedArray.includes(item.menu_id) ||
                  restrictedArray.includes(item.parent_menu_id)

              const isNotExcluded =
                  !exclusionArray.includes(item.menu_id) &&
                  !exclusionArray.includes(item.parent_menu_id)

              return isIncluded && isNotExcluded
            })
            : res.data

        let listboxData = data
        this.dataset = removeEmptyOrNull(listboxData)

        this.filter = Object.fromEntries(
            Object.keys(listboxData[0]).map(k => {
              return [k, []]
            })
        )
        this.listBoxOptions = await this.makeListBoxOptions()
        this.sortDateRelatedObjects(this.listBoxOptions)
      } catch (err) {
        // ✅ silently ignore canceled requests
        if (err.code === 'ERR_CANCELED') {
          // console.log('fetchListboxData canceled for', sqlId)
          return
        }
        // Other errors: rethrow or handle as you like
        console.error('fetchListboxData error', err)
        throw err
      }
    },
    async makeListBoxOptions() {
      let listboxData = this.dataset
      // console.clear()

      const makeOptions = (records, filterKeys, cacheKey) => {
        //make distinct values of each col
        //total cols = 4

        //cacheKey = simply, length of row + filterKeys

        const getDistinctColValues = () => {

          //for each key, we make a set to hold distinct values
          let localFilters = Object.fromEntries(
              filterKeys.map(k => [k, new Set()])
          )

          //parse through each record
          for (let row of records) {
            //for every filter-key, we add to set, this will de-dup the data
            for (let fk of filterKeys) {
              const value = row[fk];
              // Filter out null and undefined values
              if (value !== null && value !== undefined) {
                localFilters[fk].add(value);
              }
            }
          }

          //convert to a map of {k1: [distnct values for k1], k2: [distinct values for k2] .... etc}
          return Object.fromEntries(Object.entries(localFilters).map(x => {
            return [x[0], [...x[1]].sort()]
          }))
        }

        let fromCache = false; //this.listBoxCache[cacheKey]
        //let fromCache = false
        if (cacheKey && fromCache) {
          return fromCache;
        } else {
          // let ts = new Date().getTime()
          let value = getDistinctColValues();
          this.listBoxCache[cacheKey] = value;
          return value;

        }

      }

      const applyNextFilter = (currentFilter, restOfFilters, appliedFilters) => {

        let colSelected = currentFilter[0],
            colValues = currentFilter[1];

        //say 3 filters
        //salesman, brand, store
        //when nothing is selected, then distinct values of each can be used (default)
        //say one is selected, then we use that and select distinct values for rest
        //say two is selected, then use both to select distinct values for rest


        //filter records based on applied filters
        let listboxdataCopy = [...listboxData]

        for (let restFilter of restOfFilters) {
          if (restFilter[1].length > 0) {
            listboxdataCopy = listboxdataCopy.filter(x => restFilter[1].indexOf(x[restFilter[0]]) > -1);
          }
        }

        let optionsAfterRest = makeOptions(
            listboxdataCopy,
            [colSelected],
            [...Object.entries(restOfFilters), currentFilter].map(x => `${x[0]}:${x[1].join('-')}`).join()
        )

        //select records, by applying the current filter
        let recordsAfterFilter = listboxdataCopy.filter(x => colValues.indexOf(x[colSelected]) > -1);

        //from filters, remove the current filter, and previously applied filters
        let filterRemainingKeys = Object
            .keys(listboxData[0])
            .filter(x => x !== colSelected)
            .filter(x => !appliedFilters.map(y => y[0]).includes(x))

        //now we would have gotten, distinct col values for remaining filter, based on remaining data
        let options = makeOptions(
            recordsAfterFilter,
            filterRemainingKeys,
            Object.entries(this.filter).map(x => `${x[0]}:${x[1].join('-')}`).join()
        )
        return {...options, ...optionsAfterRest}
      }

      if (this.dataset.length > 0) {

        //if filter values are selected, then apply
        let initialFilterValues = makeOptions(listboxData, Object.keys(listboxData[0]), "ALL")
        let nextFilter = null;
        //iterate through each filter
        const transformedFilter = this.transformFilter(this.filter);
        let filterEntries = Object.entries(transformedFilter);
        let appliedFilters = []
        for (let currFilter of filterEntries) {

          let restOfFilters = filterEntries.filter(x => x[0] !== currFilter[0])

          //if the filter is selected
          if (currFilter[1].length > 0) {

            let prevFilter = {...(nextFilter || initialFilterValues)}
            let appliedFilter = applyNextFilter(
                currFilter,
                restOfFilters,
                appliedFilters
            )
            appliedFilters.push(currFilter)

            nextFilter = {...prevFilter, ...appliedFilter}
          }

          //else, skip this filter
        }
        return nextFilter || initialFilterValues

      } else {
        return {}

      }
    },
    sortDateRelatedObjects(listBoxOptions) {
      // Clone the object to avoid mutating the original
      const sortedOptions = {...listBoxOptions};

      for (const key in sortedOptions) {
        const values = sortedOptions[key];
        if (Array.isArray(values)) {
          // Sort date-related values in descending order
          sortedOptions[key] = values.sort((a, b) => {
            const isADate = this.isDateRelated(a);
            const isBDate = this.isDateRelated(b);

            // Both are date-related, sort by date in descending order
            if (isADate && isBDate) {
              return this.parseDate(b) - this.parseDate(a);
            }

            const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

            // Special case: Month names (case insensitive)
            if (monthPattern.test(a) && monthPattern.test(b)) {
              const monthOrder = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
              const aNormalized = a.slice(0, 3).toLowerCase(); // Normalize to lowercase
              const bNormalized = b.slice(0, 3).toLowerCase();
              return monthOrder.indexOf(bNormalized) - monthOrder.indexOf(aNormalized);
            }

            // One is date-related and the other is not
            if (isADate) {
              return -1; // Move date-related items to the front
            }

            if (isBDate) {
              return 1; // Move date-related items to the front
            }

            // Both are not date-related, sort alphabetically or numerically
            if (typeof a === 'string' && typeof b === 'string') {
              return a.localeCompare(b); // Ascending order for strings
            } else if (typeof a === 'number' && typeof b === 'number') {
              return a - b; // Ascending order for numbers
            }

            // Handle mixed data types (string vs number)
            return (typeof a < typeof b) ? -1 : 1; // Strings before numbers
          });
        }
      }

      return sortedOptions;
    },
    isDateRelated(value) {
      if (!value) return false;

      const fiscalYearPattern = /^\d{6}$/; // e.g., 202324
      const yearPattern = /^\d{4}$/; // e.g., 2023
      const fullDatePattern = /^\d{8}$/; // e.g., 20231115
      const dashDatePattern = /^\d{4}-\d{2}$/; // e.g., 2023-11
      const dashFullDatePattern = /^\d{4}-\d{2}-\d{2}$/; // e.g., 2023-11-15

      // Pattern for month names (e.g., Jan, January, etc.)
      const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

      return (
          fiscalYearPattern.test(value) ||
          yearPattern.test(value) ||
          fullDatePattern.test(value) ||
          dashDatePattern.test(value) ||
          dashFullDatePattern.test(value) ||
          monthPattern.test(value)
      );
    },

    parseDate(value) {
      if (!value) return 0;

      // Fiscal year format (YYYYMM)
      if (/^\d{6}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Year format (YYYY)
      if (/^\d{4}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Full date format (YYYYMMDD)
      if (/^\d{8}$/.test(value)) {
        return new Date(
            parseInt(value.slice(0, 4), 10), // Year
            parseInt(value.slice(4, 6), 10) - 1, // Month (0-based)
            parseInt(value.slice(6, 8), 10) // Day
        ).getTime();
      }

      // Dash-separated year-month format (YYYY-MM)
      if (/^\d{4}-\d{2}$/.test(value)) {
        const [year, month] = value.split('-').map(Number);
        return new Date(year, month - 1, 1).getTime(); // First day of the month
      }

      // Dash-separated full date format (YYYY-MM-DD)
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day).getTime();
      }

      // Month name (Jan, January, etc.)
      const monthMap = {
        jan: 0, january: 0,
        feb: 1, february: 1,
        mar: 2, march: 2,
        apr: 3, april: 3,
        may: 4,
        jun: 5, june: 5,
        jul: 6, july: 6,
        aug: 7, august: 7,
        sep: 8, september: 8,
        oct: 9, october: 9,
        nov: 10, november: 10,
        dec: 11, december: 11
      };

      const normalizedValue = value.trim().toLowerCase();
      for (const [key, month] of Object.entries(monthMap)) {
        if (normalizedValue === key.toLowerCase()) {
          return month; // Return the numeric month index
        }
      }
      return 0; // Default for non-date-related values
    },
    updateToggle() {
      if (this.$store.state.filterType !== undefined) {
        this.isToggled = this.$store.state.filterType === "dialog-filter";
      } else if (this.$store.state.userRoleRestriction.filterType !== undefined) {
        this.isToggled = this.$store.state.userRoleRestriction.filterType === "dialog-filter";
      } else {
        this.isToggled = false;
      }
    },
    loadListbox: async function () {
      let submenuParam = this.$route.params.submenuId
      await this.$store.dispatch("loadState")
      this.screenName = this.$store.state.fwConfigMenuScreenRender.filter(m => m.menuId === submenuParam).map(m => m.screenTitleDpName)[0]
      let menuMasterData = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam)
      if (menuMasterData.length === 0 && submenuParam) {
        setTimeout(() => {
          let url;
          const {homeDashboardMenuId} = this.$store.state.user;
          const roleLevelMenuId = this.$store.state.userRoleRestriction.homeDashboardMenuId;
          if (!homeDashboardMenuId) {
            url = roleLevelMenuId || '/';
          } else {
            url = homeDashboardMenuId || '/';
          }
          if (!url.includes('/')) {
            url = '/'
          }
          this.$router.push(url)
        }, 5000);
      }
      this.menuPath = menuMasterData[0].menuPath

      let menuData = this.$store.state.fwConfigMenuScreenRender.filter(item => item.screenletTitleDpName !== "File Upload")
      let columnMetadata = this.$store.state.colummnMetaData
      let actionIconsData = this.$store.state.actionIcons
      let listboxData = this.$store.state.listbox
      let currentMenuData = [];
      if (this.screenletId) {
        currentMenuData = menuData.filter(r => r.menuId === submenuParam && r.screenletInstanceId === this.screenletId)
      } else {
        currentMenuData = menuData.filter(r => r.menuId === submenuParam)
      }
      //screenlet title info
      this.screenletTitleInfo = currentMenuData[0]?.screenletTitleInfo
      let screenActionIconsSyspkArray = currentMenuData[0]?.screenActionIconsSyspkArray ? currentMenuData[0]?.screenActionIconsSyspkArray : []
      let screenListboxSyspkArray = currentMenuData[0]?.screenListboxSyspkArray ? currentMenuData[0]?.screenListboxSyspkArray : []
      let currentMenuActionIconsData = actionIconsData.filter(r => screenActionIconsSyspkArray.includes(r.syspk))
      let currentMenuListboxData = listboxData.filter(r => screenListboxSyspkArray.includes(r.syspk))

      this.screenListboxDefault = currentMenuData[0]?.screenListboxDefaultValue
      this.screenCardStyle = currentMenuData[0]?.screenCardStyle


      function sortFuncLB(a, b) {

        return screenListboxSyspkArray.indexOf(a.syspk) - screenListboxSyspkArray.indexOf(b.syspk);
      }

      function sortFuncAI(a, b) {

        return screenActionIconsSyspkArray.indexOf(a.syspk) - screenActionIconsSyspkArray.indexOf(b.syspk);
      }

      currentMenuListboxData.sort(sortFuncLB); //sorting the currentMenuListboxData
      currentMenuActionIconsData.sort(sortFuncAI); //sorting the currentMenuActionIconsData

      this.currentMenuActionIconsData = currentMenuActionIconsData //need to add in router function
      this.currentMenuListboxData = currentMenuListboxData
      this.screenListboxCount = currentMenuListboxData.length
      this.dateRangeFilterFlag = currentMenuData[0]?.dateRangeFilterDisplayFlag
      this.dateRangeFilterShortcuts = currentMenuData[0]?.dateRangeFilterShortcuts
      this.orderbyTextJson = currentMenuData[0]?.orderbyTextJson
      let currentMenuListboxSQLId = currentMenuData[0]?.screenListbox1_sqlId
      this.screenListboxType = currentMenuData[0]?.screenListboxType
      if (currentMenuListboxSQLId) {
        await this.fetchListboxData(currentMenuListboxSQLId);
      }

      function dateRangeCalc(date1, interval, dateType) {
        switch (dateType) {
          case 'month': {
            let firstDay = new Date(date1.getFullYear(), date1.getMonth() - interval, 1);
            let lastDay = new Date(date1.getFullYear(), date1.getMonth(), 0);
            return [firstDay, lastDay];
          }
          case 'day': {
            let firstDay = new Date();
            let dateOffset = (24 * 60 * 60 * 1000) * interval; //5 days
            let lastDay = new Date();
            firstDay.setTime(firstDay.getTime() - dateOffset);
            lastDay.setTime(lastDay.getTime());
            return [firstDay, lastDay];
          }
          case 'hour': {
            let firstDay = new Date();
            let dateOffset = (interval * 60 * 60 * 1000); //5 days
            let lastDay = new Date();
            firstDay.setTime(firstDay.getTime() - dateOffset);
            lastDay.setTime(lastDay.getTime());
            return [firstDay, lastDay];
          }
        }
      }

      //let shortcuts = []
      for (let key in this.dateRangeFilterShortcuts) {
        let value = this.dateRangeFilterShortcuts[key];
        for (let inKey in value) {
          let shortcut = {
            'text': key,
            onClick() {
              return dateRangeCalc(new Date(), value[inKey], inKey)
            }
          }
          this.shortcuts.push(shortcut)
        }
      }
      currentMenuListboxData.forEach((cmld, index) => {
        let bizNamefilterdim = columnMetadata.filter(c => c.columnName === cmld.listboxDimName);
        this.$set(this.screenListboxDim, index, {
          name: cmld.listboxDimName,  // The key name you were using before
          isInputField: cmld.inputField  // The new input_field boolean
        });
        this.$set(this.SlistboxDimBizName, index, bizNamefilterdim[0]?.bizName || null);
      });

      this.updateToggle();
      if (this.$store.state.deviceType === 'Mobile') {
        this.isToggled = true
      }
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false;
      this.sortKey = sortKey;
    },
    listenToRouter: function () {
      let $this = this;
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`);
        //$this.rows = []
        $this.screenListboxDim = {};
        $this.screenListboxCount = null;
        $this.optionValues = [];
        $this.activeTabIndex = 0;
        $this.isTabbedView = false;
        setTimeout(() => {
          $this.screenRender();
          $this.loadListbox();
        }, 300);
      });
    },
  },
};
</script>
<style>
.card-true {
  height: 86vh;
  overflow: auto;
}

.card-false {
  height: 93vh;
}

.refresh {
  display: inline-block;
  transform: rotate(90deg);
}

.anyWhichWayS {
  background: #c7f0c3; /* #89fb85  daf0d9 */
}

.freeFormS {
  background: #91bbf0;
}

.card-deck {
  margin: 0px;

  .card {
    margin: 0;
  }
}

.custom-headers {
  display: flex;
  border-bottom: 1px solid #ccc;
  background-color: #f5f5f5;
  padding: 0 5px;
}

.custom-header {
  cursor: pointer;
  border: 1px solid transparent;
  border-bottom: none;
  margin-right: 2px;
  border-radius: 2px 2px 0 0;
  background-color: #e0e0e0;
  transition: all 0.2s ease;
  min-width: 50px;
  /* text-align: center;*/
}

.custom-header:hover {
  background-color: #d0d0d0;
}

.custom-header.active {
  background-color:#5e8ef4;
  color: #ffffff;
  border-color: #5e8ef4;
  box-shadow: 0 -2px 6px rgba(37, 99, 235, 0.35);
  border-bottom: 1px solid white;
  margin-bottom: -1px;
  font-weight: bold;
}

.header-left-row {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

</style>
